<template>
  <el-row
    justify="center"
    type="flex"
  >
    <el-col
      :md="24"
      :lg="12"
    >
      <el-card shadow="never">
        <template #header>
          <span>Renouvellement de votre mot de passe</span>
        </template>

        <ValidationObserver
          v-if="!callbackUrl"
          v-slot="{ passes }"
        >
          <el-form>
            <el-row type="flex">
              <el-col :span="24">
                <el-alert
                  :closable="false"
                  effect="dark"
                  show-icon
                  type="info"
                >
                  <template #title>
                    Nous vous recommandons de définir votre mot de passe avec des caractères de types différents et sans accents (entre 8 et 20 caractères, majuscule, minuscule, chiffre, caractères spéciaux...)
                  </template>
                </el-alert>
              </el-col>
            </el-row>

            <el-row type="flex">
              <el-col :span="24">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="nouveau mot de passe"
                  rules="required"
                  vid="password"
                >
                  <el-form-item
                    :error="errors[0]"
                    label="Nouveau mot de passe"
                  >
                    <el-input
                      v-model="input.password"
                      autocomplete="off"
                      show-password
                      type="password"
                    />
                  </el-form-item>
                </ValidationProvider>
              </el-col>
            </el-row>

            <el-row type="flex">
              <el-col :span="24">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="confirmer le nouveau mot de passe"
                  rules="required|confirmed:password"
                >
                  <el-form-item
                    :error="errors[0]"
                    label="Confirmer le nouveau mot de passe"
                  >
                    <el-input
                      v-model="input.confirmationPassword"
                      autocomplete="off"
                      show-password
                      type="password"
                    />
                  </el-form-item>
                </ValidationProvider>
              </el-col>
            </el-row>

            <el-row type="flex">
              <el-col
                align="center"
                :span="24"
              >
                <el-button
                  v-loading="saving"
                  size="small"
                  type="primary"
                  @click="passes(enregistrer)"
                >
                  Mettre à jour
                </el-button>
              </el-col>
            </el-row>
          </el-form>
        </ValidationObserver>

        <template v-else>
          <el-row type="flex">
            <el-col
              align="center"
              :span="24"
            >
              <el-link
                :href="websiteLogin"
                type="primary"
              >
                Retourner sur le site web
              </el-link>
            </el-col>
          </el-row>
        </template>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>

import WEBSITE_URLS from '@/services/website-target'

export default {
  data () {
    return {
      websiteLogin: WEBSITE_URLS.login,
      callbackUrl: null,
      input: {
        confirmationPassword: null,
        password: null
      },
      saving: false,
      success: false
    }
  },

  methods: {
    enregistrer () {
      // Démarre l'indicateur de chargement
      this.saving = true

      // Exécute l'enregistrement auprès de l'api
      this.$store.dispatch('changePassword', {
        password: this.input.password
      })
        .then((callBackUrl) => {
          // Envoi une notification
          this.$message({
            duration: 5000,
            message: 'Enregistrement de votre nouveau mot de passe effectué avec succès',
            showClose: true,
            type: 'success'
          })

          // Redirige automatiquement l'utilisateur au bout de 5 secondres
          this.callbackUrl = callBackUrl
          setTimeout(() => {
            window.location.assign(this.websiteLogin)
          }, 5000)
        })
        .finally(() => {
          // Stop l'indicateur de chargement
          this.saving = false
        })
    }
  }
}
</script>
